import { render, staticRenderFns } from "./Synthesis.vue?vue&type=template&id=18264234&scoped=true&"
import script from "./Synthesis.vue?vue&type=script&lang=js&"
export * from "./Synthesis.vue?vue&type=script&lang=js&"
import style0 from "./Synthesis.vue?vue&type=style&index=0&id=18264234&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18264234",
  null
  
)

export default component.exports